export const DataBuildingSort = [
  {value: "id", label: "Domyślnie"},
  {value: "start_date", label: "Data rozpoczęcia rosnąco", direction: "asc"},
  {value: "start_date", label: "Data rozpoczęcia malejąco", direction: "desc"},
  {value: "end_date", label: "Data zakończenia rosnąco", direction: "asc"},
  {value: "end_date", label: "Data zakończenia malejąco", direction: "desc"},
  {value: "created_at", label: "Data Utworzenia rosnąco", direction: "asc"},
  {value: "created_at", label: "Data Utworzenia malejąco", direction: "desc"},
];
